module.exports = __webpack_public_path__ + "img/water.9a6ba371.png";